const appHelper = {
    settings: {
        languageCode: "vi",
        apiURL: "https://trans.naviconference.com",
        applicationName: "Transparent Solution",
        languages: [{code: "en", name: "English"}, {code: "vi", name: "Tiếng Việt"}],
        macAddress: "electron"
    },
    utils: null,
    init: async function () {
        if (ipcRenderer) this.settings = await ipcRenderer.invoke("synchronous-message", "window.main.getSettings");
    },
    setSetting: function (key, value) {
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch (exception) {
            console.log(exception);
        }
    },
    getSetting: function (key) {
        try {
            const value = window.localStorage.getItem(key);
            if (!value)
                return undefined;

            return JSON.parse(value);
        } catch (exception) {
            console.log(exception);
        }

        return undefined;
    },
    detectOs() {
        let userAgent = window.navigator.userAgent,
		platform = window.navigator.platform,
		macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
		windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
		iosPlatforms = ['iPhone', 'iPad', 'iPod'],
		os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1 || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'Linux';
        }
        
        return os;
    },
    openMeeting: async function (data, action = "join") {
        const os = this.detectOs();

        this.openZoomScheme(data, action, ['Android', 'iOS'].includes(os) ? 'zoomus' : 'zoommtg');
        return true;
    },
    openZoomScheme(data, action, scheme = "zoomus") {
        if (action === 'join')
        {
            location.href = `${scheme}://zoom.us/join?action=join&confno=${encodeURIComponent(data.MeetingID)}&uid=${encodeURIComponent(data.DisplayName)}&uname=${encodeURIComponent(data.DisplayName)}&browser=chrome&pwd=${encodeURIComponent(data.Password)}`;
            return;   
        }

        location.href = `${scheme}://zoom.us/join?action=start&stype=99&sid=${encodeURIComponent(data.UserID)}&uid=${encodeURIComponent(data.UserID)}&token=${encodeURIComponent(data.Token)}&zak=${encodeURIComponent(data.Zak)}&confno=${encodeURIComponent(data.MeetingID)}&uid=${encodeURIComponent(data.DisplayName)}&uname=${encodeURIComponent(data.DisplayName)}&browser=chrome&pwd=${encodeURIComponent(data.Password)}`;
    },
    isMeetingOpening: async function () {
        return false;
    },
    closeApp: async function () {
        return false;
    },
    downloadFile: async function (url) {
        if (ipcRenderer) {
            await ipcRenderer.invoke("synchronous-message", "window.main.downloadFile", url);
            return;
        }

        window.open(url)
    }
}

export default appHelper;